import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "common";
import { AppSettings } from "../../app.settings";
import { AnnouncementData } from "./announcement.model";


@Injectable({
  providedIn: "root",
})
export class AnnouncementService {
  constructor(
    private http: HttpClient,
    private settings: AppSettings,
    private configService: ConfigService
  ) {}


  query(): Observable<AnnouncementData[]> {
    return this.http.get<AnnouncementData[]>(
      `${this.settings.messages.url}/api/announcements`,
      {
        headers: this.configService.environment.cache.mediumLived,
      }
    );
  }
}
